// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.errorMessage {
    margin-bottom: 15px;
}

.mandatory_field::after {
    content: " *";
    color: red;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Blog/BlogAdd/BlogAdd.css"],"names":[],"mappings":";AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,UAAU;AACd","sourcesContent":["\n.errorMessage {\n    margin-bottom: 15px;\n}\n\n.mandatory_field::after {\n    content: \" *\";\n    color: red;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
